import React from 'react';
import { cn } from '../lib/utils';

export interface EmptyValueProps extends React.HTMLAttributes<HTMLSpanElement> {
  label?: string;
}

/** An unknown or unavailable value is never presented as zero. */
export function EmptyValue({ label = 'Not available', className, ...props }: EmptyValueProps) {
  return (
    <span
      {...props}
      className={cn('font-body text-body font-normal text-text-muted', className)}
      data-ui="empty-value"
    >
      <span aria-hidden="true">—</span>
      <span className="sr-only">{label}</span>
    </span>
  );
}
